import * as S from "./styles";

type Props<T> = {
  label: string;
  value: T;
};

export function KeyValue<T>({ label, value }: Props<T>) {
  return (
    <S.Wrapper>
      <S.Key>{label}</S.Key>
      <S.Value>{value as string}</S.Value>
    </S.Wrapper>
  );
}
